<template>
  <div class="ui-page">
    <AppContentSkeleton v-if="loading" label="Loading double requests" :columns="columns" min-width="1200px" />
    <AppErrorState v-else-if="error" :message="error" @retry="load" />
    <app-no-results v-else-if="!leads.length" design="new" title="No double requests" text="" />
    <AppCard v-else design="new" variant="table" header-density="compact">
      <AppDataTable design="new" density="dense" :rows="leads" :columns="columns" :loading="loading" min-width="1200px">
        <template #cell-name="{ row }">
          <AppTableText :text="row.name" fallback="Unnamed lead"><router-link :to="leadRoute(row)" class="ui-link">{{ row.name || 'Unnamed lead' }}</router-link></AppTableText>
        </template>
        <template #cell-stage="{ row }">
          <AppStatusBadge v-if="row.stage" design="new" compact :color="row.stage.color || ''" :label="row.stage.name" />
          <span v-else>—</span>
        </template>
        <template #cell-email="{ row }"><AppTableText :text="row.email" /></template>
        <template #cell-phone="{ row }"><AppTableText :text="row.phone" /></template>
        <template #cell-manager="{ row }"><AppTableUser :name="row.manager" /></template>
      </AppDataTable>
    </AppCard>
    <AppPagination
      v-if="!loading && !error && leads.length"
      placement="embedded"
        design="new"
        :page="page"
        :pages="pages"
        :count="count"
        :visible-count="leads.length"
        :page-size="pageSize"
        :loading="loading"
        label="Double request pages"
        @change="changePage"
    />
  </div>
</template>

<script>
import AppContentSkeleton from '@/components/AppContentSkeleton.vue'
import AppErrorState from '@/components/AppErrorState.vue'
import AppTableText from '@/components/AppTableText.vue'
import AppTableUser from '@/components/AppTableUser.vue'
import { getLeadFlowDoubleRequests } from '@/http'

export default {
  name: 'LeadFlowDoubleRequests',
  components: { AppContentSkeleton, AppErrorState, AppTableText, AppTableUser },
  data() {
    return {
      leads: [],
      loading: false,
      error: '',
      requestId: 0,
      page: 1,
      pages: 1,
      count: 0,
      pageSize: 40,
      columns: [
        { key: 'name', label: 'Lead', width: '30%' },
        { key: 'email', label: 'Email', width: '24%' },
        { key: 'phone', label: 'Phone', width: '16%' },
        { key: 'stage', label: 'Stage', width: '15%' },
        { key: 'manager', label: 'Manager', width: '15%' }
      ]
    }
  },
  created() {
    this.load()
  },
  beforeDestroy() {
    this.requestId += 1
  },
  methods: {
    leadRoute(row) {
      return { name: 'leads-detail-lead', params: { id: row.id } }
    },
    changePage(page) {
      this.page = page
      this.load()
    },
    async load() {
      const requestId = ++this.requestId
      this.loading = true
      this.error = ''
      try {
        const { data } = await getLeadFlowDoubleRequests({ page: this.page, page_size: this.pageSize })
        if (requestId !== this.requestId) return
        this.leads = data.results || []
        this.page = data.page
        this.pages = data.pages
        this.count = data.count
        this.pageSize = data.page_size
      } catch (error) {
        if (requestId !== this.requestId) return
        this.leads = []
        this.error = 'Unable to load double requests.'
      } finally {
        if (requestId === this.requestId) this.loading = false
      }
    }
  }
}
</script>
